import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_AIC_BASIC_Schema } from './M_AIC_BASIC_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';

/** 보이스 체크 리스트 조회 GetAicCallR1 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_AIC_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['AIC', 'getAicCallR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.WorkStart.getAicCallR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 보호구 조회(AiCall) GetEquipR1 */
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_AIC_BASIC_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['AIC', 'getEquipR1', params],
    queryFn: () => apiRequest('post', Global.urls.WorkStart.getEquipR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** AI콜 음성 경로 DB저장 SaveAicCallU1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_AIC_BASIC_Schema.mapper.save1);
    return apiRequest('post', Global.urls.WorkStart.saveAicCallU1, payload);
  }, options);
};

/** 작업 시작 SaveWorkStartU1 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_AIC_BASIC_Schema.mapper.save2);
    return apiRequest('post', Global.urls.WorkStart.saveWorkStartU1, payload);
  }, options);
};
